// extracted by mini-css-extract-plugin
module.exports = {"summary":"ExpansionPanel_summary__3t-9k","expanded":"ExpansionPanel_expanded__3Dqcb","icon":"ExpansionPanel_icon__27HXR"};